module.exports = __webpack_public_path__ + "img/hjk-logo-icon.3ebaa2b9.png";